import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { environment } from '@environments/environment';
import usertour from 'usertour.js';

import { UserDefinitionService } from '@services/user-definition.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `<router-outlet></router-outlet>`
})
export class AppComponent {
    private userService = inject(UserDefinitionService);

    constructor(titleService: Title) {
        titleService.setTitle(environment.companyName);

        if (environment.usertour) {
            this.initUserTour();
        }
    }

    initUserTour() {
        this.userService.getUserInfo().subscribe({
            next: (user) => {
                usertour.init('cmnxbbj32008od1lbaxmpjo59');
                usertour.identify(String(user.userId), {
                    name: user.name,
                    email: user.email,
                    signed_up_at: user.createdDate
                });
            }
        });
    }
}
